import { useState } from 'react'
import SubActivtiy from './SubActivtiy'
import Dashboardnavbar from '../../layout/Dashboardnavbar';
import Activtiy from './Activity';
import Division from './Division';


const MainDivision = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return " Sub-Activity";
            case 2:
                return "Activtiy";
            case 3:
                return "Division";
            default:
                return "Sub Company";
        }
    };
    return (
        <>
            {/* modification required on navbar */}
            <Dashboardnavbar url="Division" name={getSelectedTitle()} />
            <div className="content-tabs ">
                <div
                    className="toggle-button-area flex-row justify-between"
                    style={{ padding: "15px 30px" }}
                >
                    <div>
                        <button
                            className={
                                toggleState === 1
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(1)}
                        >
                            Sub-Activity
                        </button>

                        <button
                            className={
                                toggleState === 2
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs "
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(2)}
                        >
                            Activity
                        </button>

                        <button
                            className={
                                toggleState === 3
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(3)}
                        >
                            Division
                        </button>

                    </div>

                </div>
            </div>
            <>
                {toggleState === 1 ? <SubActivtiy /> : null}
                {toggleState === 2 ? <Activtiy /> : null}
                {toggleState === 3 ? <Division /> : null}

            </>

        </>
    );
};

export default MainDivision